import Component from '../Component';
import Sprite from 'Prototype/Sprite';

export default class ShadowComponent extends Component {
    public shadow: Sprite | null = null;
}
